import api from '../api/signup'

const state = {
    signup: false,
}

const getters = {
    getSignup: state => {
        return state.signup
    }
}

const actions = {
    getSignup({dispatch, commit}, slug) {
        return new Promise((resolve, reject) => {
            api.getSignup(slug)
            .then((success) => {
                commit('setSignup', success.items[0])
                return resolve(success)
            }).catch((failed) => {
                commit('setSignup', false)
                return reject(failed)
            })
        })
    }
}

const mutations = {
    setSignup(state, value) {
        state.signup = value
    },
}
export default {
    state, getters, actions, mutations
}
